module.exports = __webpack_public_path__ + "img/team.51e14ecd.svg";